export default "__VITE_PUBLIC_ASSET__f436cb47__"